import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

// import { MaterialSeoService } from 'libs/ecm-material/src/lib/services/material-seo.service';

import { EcmMaterialModule, MaterialSeoService } from '@ecm/material';

import { EcmDashboardRouterModule } from './ecm-dashboard-router.module';
import { dashboardTranslationFr } from './i18n/fr';

@NgModule({
    imports: [EcmDashboardRouterModule, EcmMaterialModule, RouterModule],
    providers: [MaterialSeoService],
})
export class EcmDashboardModule {
    public constructor(translate: TranslateService) {
        translate.setTranslation('fr', dashboardTranslationFr, true);
    }
}
